module.exports = __webpack_public_path__ + "img/page-loading.cf2cf9f5.gif";